import React from 'react';
import ReactDOM from 'react-dom';
import './assets/css/app.css';
import App from './App';
import HeaderCollapse from './components/HeaderCollapse';
import FollowAuthor from './components/FollowAuthor';
import BookmarkArticle from './components/BookmarkArticle';
import reportWebVitals from './reportWebVitals';
import HeaderCollapseMobile from './components/HeaderCollapseMobile';
import HeaderMenuList from './components/HeaderMenuList';

import MyBookmarks from './pages/MyBookmarks';
import MyFavoriteTags from './pages/MyFavoriteTags';
import FollowSection from './components/FollowSection';
import FollowSectionSpecial from './components/FollowSectionSpecial';
import {getBookmarks} from './config/Variables';


//var booktest=document.getElementsByClassName("bookmark_user");

//if(booktest){
 // ReactDOM.render(React.createElement('div', null, 'test2'), document.getElementsByClassName('bookmark_user')[0]); 
//}

var myEle = document.getElementById("mybookmarktest");
    if(myEle){
      ReactDOM.render(
        <React.StrictMode>
          <MyBookmarks />
        </React.StrictMode>,
        document.getElementById('mybookmarktest')
      );
      

    }
    
   


const collection = document.getElementsByClassName("bookmark_user");
    if(collection.length>0){
      if (localStorage.getItem('user-info')) {
      let user = JSON.parse(localStorage.getItem('user-info'));
      const tempas=[];
      let datt = fetch(getBookmarks, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "Accept": 'application/json',
          "Authorization": "Bearer " + user.token.access_token,
        },
        body: JSON.stringify(user)
      }).then(response => response.json())
        .then(data => {
          data.data.map(({ nid }, index2) => {
            tempas.push(nid);
          });
         // console.log(tempas.join("+"));
        //}
        
      
      // console.log("samir");
    for (let i = 0; i < collection.length; i++) {
      ReactDOM.render(
        <React.StrictMode>
          <BookmarkArticle bookmarksnid={tempas.join("+")} nodeid={collection[i].getAttribute('data-value')} />
        </React.StrictMode>,
      document.getElementsByClassName("bookmark_user")[i]
      );
    }
    window.renderMyReactApp = element => ReactDOM.render(<BookmarkArticle nodeid={element.getAttribute('data-value')}   bookmarksnid={tempas.join("+")}  />, element);   
    
  });
}else{
  for (let i = 0; i < collection.length; i++) {
    ReactDOM.render(
      <React.StrictMode>
        <BookmarkArticle  nodeid={collection[i].getAttribute('data-value')} />
      </React.StrictMode>,
    document.getElementsByClassName("bookmark_user")[i]
    );
  }
  window.renderMyReactApp = element => ReactDOM.render(<BookmarkArticle nodeid={element.getAttribute('data-value')}    />, element);   

}
  }




    var myEle = document.getElementById("mytagspage");
    if(myEle){
      ReactDOM.render(
        <React.StrictMode>
          <MyFavoriteTags />
        </React.StrictMode>,
        document.getElementById('mytagspage')
      );
      

    }

    var myEle = document.getElementById("followsection");
    if(myEle){
      ReactDOM.render(
        <React.StrictMode>
          <FollowSection />
        </React.StrictMode>,
        document.getElementById('followsection')
      );
      

    }

    var myEle = document.getElementById("FollowSectionSpecial");
    if(myEle){
      ReactDOM.render(
        <React.StrictMode>
          <FollowSectionSpecial />
        </React.StrictMode>,
        document.getElementById('FollowSectionSpecial')
      );
      

    }





  const mytagsmenu = document.getElementsByClassName("mytagsmenu");
      if(mytagsmenu.length>0){
        for (let i = 0; i < mytagsmenu.length; i++) {
          ReactDOM.render(
            <React.StrictMode>
              <HeaderMenuList />
            </React.StrictMode>,
             document.getElementsByClassName("mytagsmenu")[i]
          );
        }
    
        }



    

    const follow_author = document.getElementsByClassName("follow_author");
    if(follow_author.length>0){
    for (let i = 0; i < follow_author.length; i++) {
      ReactDOM.render(
        <React.StrictMode>
          <FollowAuthor nodeid={follow_author[i].getAttribute('data-value')} />
        </React.StrictMode>,
      document.getElementsByClassName("follow_author")[i]
      );
      }
    }
  

    var menu_collapse = document.getElementById("menu_collapse_mobile");
    if(menu_collapse){
ReactDOM.render(
  <React.StrictMode>
    <HeaderCollapseMobile />
  </React.StrictMode>,
  document.getElementById('menu_collapse_mobile')
);
    }



    var menu_collapse = document.getElementById("menu_collapse");
    if(menu_collapse){
ReactDOM.render(
  <React.StrictMode>
    <HeaderCollapse />
  </React.StrictMode>,
  document.getElementById('menu_collapse')
);
    }

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
